





























































import {
  defineComponent, ref, computed, Ref, watch, onMounted,
} from '@vue/composition-api';
import { FCSelect } from '@fc/angie-ui';
import FCImage from '~/components/FCImage.vue';
import WrapGloveSize from './WrapGloveSize.vue';

export default defineComponent({
  name: 'PartnerWorkoutPack',
  components: {
    FCImage,
    FCSelect,
    WrapGloveSize,
  },
  props: {
    upsellData: {
      type: Object,
      required: true,
    },
    errorMessage: {
      type: String,
      default: 'Size is required before adding to cart.',
    },
  },
  setup(props, context) {
    const { emit } = context;
    const isChecked = ref(false);
    const partnerWorkoutPackError = ref(false);
    const selectedPartnerWorkoutPack: Ref<string | null> = ref(null);

    const partnerWorkoutPackOptions = computed(() => props.upsellData?.variants?.map((variant: any) => ({
      key: variant.id,
      name: variant.name,
    })));

    function toggleCheck() {
      isChecked.value = !isChecked.value;

      emit('update:checked', isChecked.value);

      if (!isChecked.value) {
        selectedPartnerWorkoutPack.value = null;
        emit('update:selection', null);
      }
    }

    watch(selectedPartnerWorkoutPack, (newValue) => {
      if (newValue) {
        const selectedVariant = props.upsellData.variants.find((variant: any) => variant.id === newValue);
        emit('update:selection', selectedVariant);
      } else {
        emit('update:selection', null);
      }
    });

    watch(partnerWorkoutPackError, (newValue) => {
      emit('update:error', newValue);
    });

    onMounted(() => {
      emit('register', {
        setError: (hasError: boolean) => {
          partnerWorkoutPackError.value = hasError;
        },
      });
    });

    const trackClickTitle = computed(() => {
      const state = isChecked.value ? 'unchecked' : 'checked';
      return `DoubleYourGear_Checkbox_${state}`;
    });

    return {
      isChecked,
      selectedPartnerWorkoutPack,
      partnerWorkoutPackError,
      partnerWorkoutPackOptions,
      toggleCheck,
      trackClickTitle,

    };
  },
});
